import script from "./HrPromptDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPromptDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrPromptDialog.vue?vue&type=style&index=0&id=116a1ff0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116a1ff0"]])

export default __exports__